angular.module("leanlaw").controller("RemoveLineItemModalController", ["$scope", "close", "typeLabel", "adjustOption", function ($scope, close, typeLabel, adjustOption) {
  $scope.typeLabel = typeLabel;
  $scope.radioListOptions = [{
    header: `Save ${typeLabel} for Later`,
    content: `${typeLabel} will be removed from this invoice but can still be added to a new invoice later`,
    value: 'later'
  }];
  if (adjustOption) {
    $scope.radioListOptions.push({
      header: `Adjust ${typeLabel} to Zero`,
      content: `${typeLabel} will be removed from invoicing and appear in reports as a write-down`,
      value: 'adjust'
    });
  }
  $scope.radioListOptions.push({
    header: `Delete ${typeLabel} permanently`,
    content: `${typeLabel} will be permanently deleted as if it never existed`,
    value: 'delete'
  });
  $scope.confirm = function () {
    console.log("User selected", $scope.selectedAction);
    close({
      action: $scope.selectedAction
    });
  };
  $scope.reject = function () {
    close(false);
  };
}]);